// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"390":"d648eb28","690":"8cc6faea","761":"d0deef33"}[chunkId] || chunkId) + "." + {"214":"0e94db71a4b785c4","390":"2d245964f6ead9f6","524":"526dfeee254eed73","679":"ab91f5d5578ac5d9","690":"7a08f8caccfd12b2","761":"ae9fba77c41682f7"}[chunkId] + ".js";
};